import { render } from "./ShowDataScreen.vue?vue&type=template&id=04089f90"
import script from "./ShowDataScreen.vue?vue&type=script&lang=js"
export * from "./ShowDataScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/tech_touch_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__